<template>
  <v-card class="pa-4" outlined rounded="lg">
    <h6>Restrições de venda</h6>

    <b>Formas de pagamento online</b>
    <div class="d-flex flex-wrap gap-x-3">
      <v-checkbox
        v-for="method in paymentMethodList"
        :key="method.value"
        v-model="paymentMethods"
        :label="method.text"
        :value="method.value"
        dense
        multiple
        :disabled="loading"
      />
    </div>
    <v-alert v-if="error" type="error" text dense>
      {{ error }}
    </v-alert>

    <div class="d-flex justify-space-between flex-wrap">
      <v-spacer />
      <v-btn
        :disabled="loading || paymentMethods.length === 0"
        small
        color="success"
        depressed
        @click="save"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import PARTY from "@/services/admin/parties";
import moment from "moment";

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    active: false,
    loading: false,
    error: false,

    paymentMethodList: [
      {
        text: "Cartão de crédito",
        value: "CREDIT_CARD",
      },
      {
        text: "Pix",
        value: "PIX",
      },
      {
        text: "QR Code",
        value: "QR_CODE",
      },
    ],
    paymentMethods: [],

    startAnalysisDate: 0,
    maximumAnalisysScore: 0,
  }),
  methods: {
    async save(date) {
      try {
        this.loading = true;
        this.error = null;

        const disallowOnlinePaymentMethods = this.disallowOnlinePaymentMethods;

        await PARTY.update(this.party.id, {
          disallowOnlinePaymentMethods: disallowOnlinePaymentMethods,
        });

        this.active = true;
      } catch (error) {
        this.error = error.message || error;
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    disallowOnlinePaymentMethods() {
      return this.paymentMethodList
        .filter((method) => !this.paymentMethods.includes(method.value))
        .map((method) => method.value);
    },
  },
  mounted() {
    const disallowOnlinePaymentMethods =
      this.party.disallowOnlinePaymentMethods || [];
    this.paymentMethods = this.paymentMethodList.reduce((acc, method) => {
      if (!disallowOnlinePaymentMethods.includes(method.value))
        acc.push(method.value);

      return acc;
    }, []);
  },
};
</script>

<style>
</style>